import { Icon } from '@chakra-ui/react';

export const CloseNav = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M5.45455 6.36364C5.20351 6.1126 5.20351 5.70559 5.45455 5.45455V5.45455C5.70558 5.20351 6.1126 5.20351 6.36364 5.45455L14.5455 13.6364C14.7965 13.8874 14.7965 14.2944 14.5455 14.5455V14.5455C14.2944 14.7965 13.8874 14.7965 13.6364 14.5455L5.45455 6.36364Z"
      fill="currentColor"
    />
    <path
      d="M6.3637 14.5455C6.11266 14.7965 5.70565 14.7965 5.45461 14.5455V14.5455C5.20357 14.2944 5.20357 13.8874 5.45461 13.6364L13.6364 5.45455C13.8875 5.20351 14.2945 5.20351 14.5455 5.45455V5.45455C14.7966 5.70558 14.7966 6.1126 14.5455 6.36364L6.3637 14.5455Z"
      fill="currentColor"
    />
  </Icon>
);
